import { Product } from '../../store/data/types'
import React, { memo } from 'react'
import { getPromotionsDaily } from '../../services/productApi'
import { LoadablePage, LoadablePageProps } from './LoadablePage'
import { ProductsGrid } from '../templates/ProductsGrid'
import { StyledLinkToHome } from '../atoms/styles/LinkBackHomeDiv.style'
import { LinkBackHome } from '../atoms'

interface PromotionsDailyProps {
  products: Product[]
}

const _LinkHome = memo(() => (
  <StyledLinkToHome>
    <LinkBackHome />
  </StyledLinkToHome>
))

const _Grid = ({ products }: PromotionsDailyProps) => {
  const header = {
    node: <_LinkHome />,
    height: 63,
  }

  return <ProductsGrid context={['dailyOffers']} data={products} header={header} />
}
export const promotionsDailyFetch = async (): Promise<PromotionsDailyProps> => {
  const data = await getPromotionsDaily()
  return {
    products: data.products,
  }
}
export const PromotionsDaily = (props: LoadablePageProps<PromotionsDailyProps>) => {
  return (
    <LoadablePage {...props} dataFetch={promotionsDailyFetch}>
      {_Grid}
    </LoadablePage>
  )
}
